var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{ref:"dom",staticClass:"dom"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }